import { connect } from 'react-redux'
import MaintenanceRefineComponent from '../components/MaintenanceRefineComponent.jsx';
import {
	forwardToFindRefinableMCases,
	forwardToRefineMaintenanceCase,
	forwardToAssignModifyingMCaseTarget
} from '../actions';

const mapStateToProps = (state) => ({

	request: state.getIn(['maintenanceRefineReducer', 'request']),
	response: state.getIn(['maintenanceRefineReducer', 'response']),
	options: state.getIn(['maintenanceRefineReducer', 'options']),

	roles: state.getIn(['authReducer', 'roles']),
})

const mapDispatchToProps = (dispatch) => ({
	findRefinableMCases: () => {
		dispatch(forwardToFindRefinableMCases());
	},

	refineMCase: (pk, operator) => {
		dispatch(forwardToRefineMaintenanceCase(pk, operator));
	},

	assignModifyingTarget: (mCase) => {
		dispatch(forwardToAssignModifyingMCaseTarget(mCase));
	}

})

const MaintenanceRefineContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(MaintenanceRefineComponent)

export default MaintenanceRefineContainer;


// WEBPACK FOOTER //
// ./src/containers/MaintenanceRefineContainer.jsx